import classNames from 'classnames'

import { ButtonCopy } from '@apps-common/components/elements/button'
import { MESSAGE_VALUE_NOT_ASSIGNED } from '@apps-common/config/app-messages'
import { valueStringCheck } from '@apps-common/helpers/value-string-check'

interface IProps {
  value?: string
  noValue?: string
  textValue?: string
  noTextValue?: string
  className?: string
  iconClassName?: string
  showCopyValue?: boolean
}

export const CopyWithText: React.FC<IProps> = (props) => {
  const { value, noValue, textValue, noTextValue, className, iconClassName, showCopyValue } = props

  return (
    <div className={classNames('jost-light text-[0.85rem] flex items-center justify-start max-w-[80%]', className)}>
      <p className='text-ellipsis whitespace-nowrap overflow-hidden'>
        {valueStringCheck(textValue, [], noTextValue || MESSAGE_VALUE_NOT_ASSIGNED)}
      </p>
      <ButtonCopy value={value} noValue={noValue} className='jost-medium' iconClassName={iconClassName} showValue={showCopyValue} />
    </div>
  )
}
